module.exports = __webpack_public_path__ + "static/bskytxt-812db90352df0ff58bf3996e6cee2d4f.png";